import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiMenuAlt3, HiX } from 'react-icons/hi';

const NAV = [
  { href:'#about',      label:'About'      },
  { href:'#skills',     label:'Skills'     },
  { href:'#experience', label:'Experience' },
  { href:'#projects',   label:'Projects'   },
  { href:'#services',   label:'Services'   },
  { href:'#contact',    label:'Contact'    },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const [active, setActive]     = useState('');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      const ids = NAV.map(n => n.href.slice(1));
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el && window.scrollY >= el.offsetTop - 120) {
          setActive(NAV[i].href);
          break;
        }
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0,   opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'py-3 bg-[#07070f]/90 backdrop-blur-xl border-b border-white/[0.05] shadow-2xl shadow-violet-900/10'
          : 'py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">

        {/* Logo */}
        <a href="#hero" className="flex items-center gap-2.5 group">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center font-mono font-bold text-sm text-white neon-v">
            MK
          </div>
          <span className="font-bold text-white text-[17px] hidden sm:block">
            Mustafa<span className="grad-text">.dev</span>
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-1">
          {NAV.map(n => (
            <a key={n.href} href={n.href}
              className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                active === n.href ? 'text-violet-400' : 'text-slate-400 hover:text-white'
              }`}
            >
              {active === n.href && (
                <motion.span layoutId="pill"
                  className="absolute inset-0 bg-violet-500/10 rounded-lg border border-violet-500/20"
                  transition={{ type:'spring', stiffness:400, damping:30 }}
                />
              )}
              <span className="relative z-10">{n.label}</span>
            </a>
          ))}
        </div>

        {/* Hire Me */}
        <motion.a href="#contact"
          whileHover={{ scale:1.05, y:-1 }}
          whileTap={{ scale:0.97 }}
          className="hidden md:flex px-5 py-2 text-sm font-semibold text-white rounded-lg btn-primary"
        >
          Hire Me
        </motion.a>

        {/* Mobile toggle */}
        <button className="md:hidden text-slate-300 hover:text-white transition-colors"
          onClick={() => setOpen(v => !v)}>
          {open ? <HiX size={24}/> : <HiMenuAlt3 size={24}/>}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity:0, height:0 }}
            animate={{ opacity:1, height:'auto' }}
            exit={{ opacity:0, height:0 }}
            transition={{ duration:0.3 }}
            className="md:hidden overflow-hidden bg-[#0d0d1a]/95 backdrop-blur-xl border-b border-white/[0.05]"
          >
            <div className="px-6 py-4 flex flex-col gap-1">
              {NAV.map((n, i) => (
                <motion.a key={n.href} href={n.href}
                  initial={{ x:-20, opacity:0 }}
                  animate={{ x:0, opacity:1 }}
                  transition={{ delay: i * 0.05 }}
                  onClick={() => setOpen(false)}
                  className="py-3 px-4 text-slate-300 hover:text-violet-400 hover:bg-violet-500/10 rounded-lg transition-all font-medium"
                >
                  {n.label}
                </motion.a>
              ))}
              <a href="#contact" onClick={() => setOpen(false)}
                className="mt-2 py-3 px-4 text-center font-semibold text-white rounded-lg btn-primary">
                Hire Me
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}
